export function clearAuthSession() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authEmail');
}

export function redirectToAuthWithReturnPath() {
  const currentPath = `${window.location.pathname}${window.location.search}`;
  const redirect = encodeURIComponent(currentPath || '/campaigns');
  window.location.assign(`/auth?redirect=${redirect}&reason=session_expired`);
}

export function handleUnauthorized() {
  clearAuthSession();
  redirectToAuthWithReturnPath();
}

export async function authFetch(input, init = {}) {
  const token = localStorage.getItem('authToken');
  const headers = new Headers(init.headers || {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (response.status === 401) {
    handleUnauthorized();
  }

  return response;
}
